export const DYNAMIC_ICON = '__dynamic' as const;
